module.exports = "../../static/img/4.d7934a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_carousel/4.jpg
// module id = 2Ssp
// module chunks = 1